import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import OrderCard from "../ones/OrderCard"


export default function OrderHistory() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [orders, setOrders] = useState([]);

  async function init() {
    setReady(false);
    await callApi('get-my-library', {}).then((response) => {
      if (response.status === 1) {
        setOrders(response.data.orders || []);
      } else {
        setOrders([]);
        appContext.tellError(response.msg || 'Could not load order history');
      }
    })
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <>
      <CategoryHero
        eyebrow="ORDER HISTORY"
        title="Your complete payment activity."
        description="Review paid, pending and cancelled orders, and open pending orders to retry the USSD push."
      />

      <div className="container marketplace-page-container">
        <h6 className="main-section-title">Order History</h6>
        {
          ready ?
            orders.length > 0 ?
              <div className="d-flex flex-column gap-3">
                {
                  orders.map((order) => <OrderCard data={order} key={order.uuid} />)
                }
              </div>
              :
              <div className="marketplace-empty-state">No orders were found.</div>
            :
            <div className="mSupportLoading">{getInlineLoader()}</div>
        }
      </div>

      <Footer />
    </>
  )
}
